import { Fieldset, Grid, Select, Space, TextInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { IconTextCaption } from '@tabler/icons-react';
import { FormBranchMultiSelector } from '../../../components/form/FormBranchMultiSelector';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { useAvailableAccountRole } from '../hooks/useAvailableAccountRole';
import { PasswordInputs } from './PasswordInputs';

type UpsertAccountFormProps = {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	form: UseFormReturnType<any, (values: any) => any>;
	isEdit?: boolean;
	selectedBranchIds?: string[];
};

export function UpsertAccountForm({
	form,
	isEdit = false,
	selectedBranchIds,
}: UpsertAccountFormProps) {
	const selectableRoles = useAvailableAccountRole();

	return (
		<>
			<Fieldset legend={'Information'}>
				<Grid>
					<Grid.Col span={4}>
						<TextInput
							label={'First Name'}
							placeholder={'Insert first name...'}
							leftSection={<IconTextCaption {...defaultIconStyle} />}
							key={form.key('firstName')}
							{...form.getInputProps('firstName')}
							data-cy="firstName-input"
						/>
					</Grid.Col>
					<Grid.Col span={4}>
						<TextInput
							label={'Last Name'}
							placeholder={'Insert last name...'}
							leftSection={<IconTextCaption {...defaultIconStyle} />}
							key={form.key('lastName')}
							{...form.getInputProps('lastName')}
							data-cy="lastName-input"
						/>
					</Grid.Col>
					<Grid.Col span={4}>
						<TextInput
							label={'Email'}
							placeholder={'Insert email...'}
							leftSection={<IconTextCaption {...defaultIconStyle} />}
							key={form.key('email')}
							{...form.getInputProps('email')}
							data-cy="email-input"
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<FormBranchMultiSelector
							form={form}
							property={'branchIds'}
							placeHolder="Select branches that user is authorised to interact with..."
							preselectedBranchIds={selectedBranchIds}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<Select
							label={'Role'}
							placeholder={'Select role...'}
							data={selectableRoles}
							leftSection={<IconTextCaption {...defaultIconStyle} />}
							key={form.key('roleId')}
							{...form.getInputProps('roleId')}
							data-cy="roleId-input"
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
			<Space h={20} />
			<Fieldset legend={'Sign-In Credentials'}>
				<Grid>
					<Grid.Col span={12}>
						<TextInput
							label={'Username'}
							placeholder={'Insert username...'}
							leftSection={<IconTextCaption {...defaultIconStyle} />}
							key={form.key('username')}
							{...form.getInputProps('username')}
							data-cy="username-input"
						/>
					</Grid.Col>
					{!isEdit && <PasswordInputs form={form} inline />}
				</Grid>
			</Fieldset>
		</>
	);
}
